<template>
    <info-card-base>
        <template #title>
            {{ period.title }}
        </template>

        <template #price>
            <template v-if="period.is_trial || period.price == 0">
                Gratis
            </template>

            <template v-else-if="period.price">
                Rp {{ price }}
            </template>
        </template>

        <template #description v-if="period.description">
            <p
                v-for="(description, i) in descriptions"
                :key="i"
            >
                {{ description }}
            </p>
        </template>
    </info-card-base>
</template>

<script>
import priceFormat from '@/tools/priceFormat'
import InfoCardBase from './InfoCardBase.vue'

export default {
    props: {
        period: {
            type: Object,
            required: true
        }
    },

    components: {
        InfoCardBase
    },

    computed: {
        descriptions() {
            return this.period.description.split('\n')
        },

        price() {
            return priceFormat(this.period.price)
        },
    },
}
</script>
